// Live transliteration on the alphabet page. Without this file the form is a
// plain GET with a "Write it" button and the server renders exactly the same
// thing, so nothing here is load-bearing.
//
// The letter map is READ OUT OF THE TABLE already on the page rather than
// embedded a second time. One copy of the mapping means the box can never
// disagree with the table printed beneath it — and the table is itself fetched
// data, not something typed.
//
// It is a change of script and not a translation, which is why a letter with
// no Enochian form is rendered as a NAMED GAP and never quietly replaced.
const UNWRITTEN = ["J", "K", "W"];

function readMapping(root) {
  const mapping = new Map();
  root.querySelectorAll("[data-testid^='enochian-letter-']").forEach((row) => {
    const image = row.querySelector("img");
    const cells = row.querySelectorAll("td, th");
    if (!image || cells.length < 3) return;
    const name = cells[1].textContent.trim();
    const dotted = name.includes("dotted");
    cells[2].textContent.trim().split("/").forEach((letter) => {
      const key = letter.trim().toUpperCase();
      if (!key) return;
      // Y takes the dotted form, I the plain one; both are called Gon.
      const preferred = (key === "Y") === dotted;
      if (!mapping.has(key) || preferred) mapping.set(key, { src: image.src, name });
    });
  });
  return mapping;
}

function render(result, text, mapping) {
  const script = document.createElement("p");
  script.className = "enochian-write__script";
  script.dir = "rtl";
  script.dataset.testid = "enochian-script";

  const gaps = [];
  let wrote = false;

  for (const character of text) {
    const key = character.toUpperCase();
    const letter = mapping.get(key);
    if (letter) {
      const span = document.createElement("span");
      span.className = "enochian-write__letter";
      span.title = `${letter.name} · ${key}`;
      const image = document.createElement("img");
      image.src = letter.src;
      image.alt = letter.name;
      span.append(image);
      script.append(span);
      wrote = true;
    } else if (/[A-Z]/.test(key)) {
      const span = document.createElement("span");
      span.className = "enochian-write__gap";
      span.title = UNWRITTEN.includes(key)
        ? `Dee's alphabet has no letter for ${key}`
        : `no letter is recorded for ${key}`;
      span.textContent = key;
      script.append(span);
      if (!gaps.includes(key)) gaps.push(key);
    } else {
      const span = document.createElement("span");
      span.className = "enochian-write__break";
      span.textContent = character;
      script.append(span);
    }
  }

  const note = document.createElement("p");
  note.className = "enochian-write__note";
  if (!wrote) {
    note.dataset.testid = "enochian-nothing";
    note.textContent = text.trim()
      ? "The entered text contains no letters that this alphabet can represent."
      : "";
    result.replaceChildren(note);
    return;
  }
  note.textContent = "Right to left, as Dee writes it.";
  if (gaps.length) {
    const named = gaps.length === 1 ? gaps[0] : `${gaps.slice(0, -1).join(", ")} and ${gaps.at(-1)}`;
    const verb = gaps.length === 1 ? "is" : "are";
    const noun = gaps.length === 1 ? "a letter" : "letters";
    note.textContent += ` ${named} ${verb} left as ${noun} because his alphabet has none —` +
      " nothing close enough is put in their place.";
  }
  result.replaceChildren(script, note);
}

export function enhance(form) {
  if (form.dataset.enochianReady) return;
  form.dataset.enochianReady = "true";

  const input = form.querySelector("input[type=search]");
  const result = document.querySelector("[data-enochian-result]");
  const mapping = readMapping(document);
  if (!input || !result || mapping.size === 0) return;

  // The button becomes redundant once every keystroke redraws, but Enter must
  // not reload the page and lose what is already on screen.
  const submit = form.querySelector("[data-enochian-submit]");
  if (submit) submit.hidden = true;
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    render(result, input.value, mapping);
  });
  input.addEventListener("input", () => render(result, input.value, mapping));
}

export function start() {
  document.querySelectorAll("[data-enochian-form]").forEach(enhance);
}

document.addEventListener("DOMContentLoaded", start);
document.addEventListener("turbo:load", start);
